import { useCallback, useEffect, useRef } from 'react';

export function useDebounceFn<T>(fn: (args: T) => void, delay: number): (args: T) => void {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  // nosemgrep:semgrep-rules.ui-useEffect
  useEffect(() => {
    return (): void => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [fn, delay]);

  return useCallback(
    (args: T) => {
      timeoutRef.current = setTimeout(() => fn(args), delay);
    },
    [fn, delay]
  );
}
